import { PhosphorFloppyButton } from "components/Atoms/PhosphorIconButton";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";

interface Props {
  initialSubject: server.dto.FavoriteSubject
  onCreate?: (subject: server.dto.FavoriteSubject) => void
  onEdit?: (subject: server.dto.FavoriteSubject) => void
}

const EditedSubjectRowCard = (props: Props) => {
  const [subject, setSubject] = React.useState<server.dto.FavoriteSubject>(props.initialSubject);
  const [hasError, setHasError] = React.useState<boolean>(false);
  const [isSaving, setIsSaving] = React.useState<boolean>(false);

  const update = (value: string) => {
    setSubject({ ...subject, subjectValue: value });
    setHasError(false);
  };

  const onSaveClick = () => {
    if (isSaving) {
      return;
    }

    if (subject.subjectValue.trim() === "") {
      setHasError(true);
      return;
    }

    setIsSaving(true);
    props.onCreate ? props.onCreate(subject) : props.onEdit(subject);
  };

  return <div>
    <div className="grow1">
      <OptionalTextInput onEnter={onSaveClick} disabled={isSaving} hasError={hasError} value={subject.subjectValue} onChange={update} maxLength={25} />
    </div>
    <PhosphorFloppyButton
      layout="in-square"
      onClick={onSaveClick}
    />
  </div>;
};

export default EditedSubjectRowCard;